import "../styles/StyleGuidePage.css";
import Footer from "../../../../../components/Footer/Footer";
import useStyleGuideData from "../hooks/useStyleGuideData";

import StyleGuideSkeleton from "../components/StyleGuideSkeleton";
import HeroSection from "../components/HeroSection";
import StepsSection from "../components/StepsSection";
import StyleBlocks from "../components/StyleBlocks";

export default function StyleGuidePage() {
  const { data, loading, error } = useStyleGuideData();

  if (loading) return <StyleGuideSkeleton />;
  if (error) return <p className="error">{error}</p>;
  if (!data) return null;

  return (
    <>
      <div className="sizeguide-container">
        <HeroSection banner={data.style_guide_banners} />

        <StepsSection steps={data.setup_find_your_perfect} />

        <StyleBlocks styles={data.content} />
      </div>

      <Footer />
    </>
  );
}
